<button
  *ngIf="profiles.length > 0 && diagnosticsEnabled"
  type="button"
  mat-icon-button
  class="diagnostic-trigger"
  [matTooltip]="'DIAGNOSTIC.TRIGGER.TOOLTIP' | translate"
  [attr.aria-label]="'DIAGNOSTIC.TRIGGER.TOOLTIP' | translate"
  [disabled]="capturing"
  (click)="openModal()"
>
  <mat-icon *ngIf="!capturing" fontSet="material-icons-outlined"
    >bug_report</mat-icon
  >
  <mat-progress-spinner
    *ngIf="capturing"
    mode="indeterminate"
    diameter="20"
  ></mat-progress-spinner>
</button>
